/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _Avatar from './avatar.js';
import _AvatarGroup from './group.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-1461d230.js';
import '@babel/runtime/helpers/defineProperty';
import 'vue';
import './props.js';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import '@vue/composition-api';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '../image/index.js';
import '../image/image.js';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/omit';
import 'lodash/isFunction';
import 'tdesign-icons-vue';
import '../_common/js/utils/observe.js';
import '../config-provider/useConfig.js';
import '../image/props.js';
import '../space/index.js';
import '../space/space.js';
import '../space/props.js';
import '../hooks/useConfig.js';
import '../space/type.js';
import 'lodash/capitalize';
import '../hooks/index.js';
import '../hooks/slots.js';
import 'lodash/isArray';
import '../hooks/useCommonClassName.js';
import '../hooks/useDefaultValue.js';
import '../hooks/useDestroyOnClose.js';
import '../hooks/useElementLazyRender.js';
import '../hooks/useFormDisabled.js';
import '../hooks/useGlobalIcon.js';
import '../hooks/useLazyLoad.js';
import '../hooks/useResizeObserver.js';
import '../hooks/useVirtualScrollNew.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../hooks/useVModel.js';
import '../hooks/useImagePreviewUrl.js';
import '../_common/js/upload/utils.js';
import '../_common/js/log/log.js';
import '../utils/map-props.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../image/type.js';
import '../utils/mixins.js';
import './avatar-group-props.js';

var Avatar = withInstall(_Avatar);
var AvatarGroup = withInstall(_AvatarGroup);

export { Avatar, AvatarGroup, Avatar as default };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/avatar/index.js
// module id = null
// module chunks = 